export default {
    // アプリ個別の定義
    main: {
        menu: {
            trials: '試行',
        },
        translate: {
            ja: '日本語',
            en: 'English',
        },
    },
    trials: {
        help00: {
            //common all reset
            create_kc: 'すべてのアップロードデータをリセットし<br>Step1-1に戻ります。',
        },
        help01: {
            //common table's help
            create_kc: 'label列では正解ラベルを示します。<br>1はPOS、結果がPositive、<br>0はNEG、結果がNegativeであることを表します。',
        },
        help02: {
            //Step 1 button
            create_kc: '学習データを元に重要な特徴の組み合わせを生成します。',
        },
        help03: {
            //Step 1 button
            create_kc: 'アップロードした学習用データを消去し、<br>再アップロードが可能となります。',
        },
        help04: {
            //Step 2 button
            create_kc: '「重要な組み合わせ」に評価の重みをつけ<br>判断に利用できるようにします。',
        },
        help05: {
            //common chart's help
            create_kc: 'POSは肯定的（Positive）な評価を表します。<br>NEGは否定的（Negative）な評価を表します。',
        },
        help06: {
            //Step 3 button
            create_kc: '予測の準備を開始します。',
        },
        help07: {
            //Step 4 button
            create_kc: '予測を行います。',
        },
        help08: {
            //Step 4 clear button
            create_kc: 'アップロードした予測用データを消去し、<br>再アップロードが可能となります。',
        },
        title: 'Wide Learning™ 体験ツール - Hello, Wide Learning!',
        header: {
            logo: {
                img: '/assets/image/logo.svg',
                url: '/ja/index.html',
            },
            home: {
                text: 'HOME',
                url: '/ja/index.html',
            },
            example: {
                text: '事例紹介',
                url: '/ja/examples/index.html',
            },
            whats_wl: {
                text: 'Wide Learning&trade;とは',
                url: '/ja/whatsWL/index.html',
            },
            about_us: {
                text: 'AboutUs',
                url: '/ja/aboutUs/index.html',
            },
            trial_tool: {
                text: 'Trial Tool',
                url: '/ja/trialTool/index.html',
            },
        },
        footer: {
            home: {
                text: 'HOME',
                url: '/ja/index.html',
            },
            example: {
                text: '事例紹介',
                url: '/ja/examples/index.html',
            },
            whats_wl: {
                text: 'Wide Learning&trade;とは？',
                url: '/ja/whatsWL/index.html',
            },
            casestudy01: {
                text: '事例紹介：哺乳類判別',
                url: '/ja/whatsWL/casestudy01.html',
            },
            casestudy02: {
                text: '事例紹介：選挙の要因の発見',
                url: '/ja/whatsWL/casestudy02.html',
            },
            casestudy03: {
                text: '事例紹介：新型コロナ施策の分析',
                url: '/ja/whatsWL/casestudy03.html',
            },
            about_us: {
                text: 'AboutUs',
                url: '/ja/aboutUs/index.html',
            },
            trial_tool: {
                text: 'Trial Tool',
                url: '/ja/trialTool/index.html',
            },
            privacy: {
                text: '個人情報保護ポリシーについて',
                url: '/ja/privacy.html',
            },
            contact: {
                text: 'お問い合わせ',
                url: '/ja/contact/link.html',
            },
        },
        menu: {
            cheat_sheet: {
                label: '手順シート',
                img_url_train_data: '/trials/images/step_1-2.svg',
                img_url_train_result: '/trials/images/step_3.svg',
                img_url_predict_data: '/trials/images/step_4.svg',
                img_url_predict_result: '/trials/images/step_5.svg',
            },
            reset: 'リセット',
            step1: {
                label: '<span class="stepNumber1">Step:1</span>学習用データを<br>準備しよう！',
                step1: {
                    label: '<span class="stepNumber1_1">1-1</span>学習用データの<br>アップロード',
                },
                step2: {
                    label: '<span class="stepNumber1_2">1-1</span>アップロードデータの<br>確認',
                },
                step3: {
                    label: '<span class="stepNumber1_3 stepNumberOption">Option</span>学習用データの<br>確認',
                },
                button: {
                    create_kc: 'Step2に進む',
                    creating_kc: '組み合わせ生成中',
                    format: '学習用データクリア',
                },
            },
            step2: {
                label: '<span class="stepNumber2">Step:2</span>重要な項目の組み合わせを<br>確認しよう！',
                step1: {
                    label: '<span class="stepNumber2_1">2-1</span>重要な項目の組み合わせ一覧',
                },
                button: {
                    start_training: 'Step3に進む',
                    training: '重みつけ処理中',
                },
            },
            step3: {
                label: '<span class="stepNumber3">Step:3</span>学習結果を<br>確認しよう！',
                step1: {
                    label: '<span class="stepNumber3_1">3-1</span>学習結果：全体',
                    button: {
                        to_all: '全体の学習結果に戻る',
                        to_params: '学習結果の評価値の確認はこちら',
                        to_params_prefix: '[中級者向け]',
                    },
                },
                step2: {
                    label: '<span class="stepNumber3_2">3-2</span>学習結果：個別',
                },
                button: {
                    next: 'Step4に進む',
                },
            },
            step4: {
                label: '<span class="stepNumber4">Step:4</span>予測用データを<br>準備しよう！',
                step1: {
                    label: '<span class="stepNumber4_1">4-1</span>全体予測用データの<br>アップロード',
                },
                step2: {
                    label: '<span class="stepNumber4_2">4-1</span>アップロードデータの確認',
                },
                step3: {
                    label: '<span class="stepNumber4_3 stepNumberOption">Option</span>予測用データの<br>確認',
                },
                button: {
                    start_predict: 'Step5に進む',
                    predicting: '予測中',
                    format: '予測用データクリア',
                },
            },
            step5: {
                label: '<span class="stepNumber5">Step:5</span>予測結果を<br>確認しよう！',
                step1: {
                    label: '<span class="stepNumber5_1">5-1</span>予測結果：個別',
                },
            },
        },
        note: {
            step1: {
                text: 'ブラウザはGoogle Chromeの最新版を推奨しています。動作環境・制限事項はこちら。',
                url: '/ja/trialTool/faq.html#faq003',
            },
        },
        description: {
            step1: {
                step1: {
                    before:
                    '学習用データのCSVファイルをアップロードします。ファイルを下のスペースにドラッグ＆ドロップまたはプルダウン選択してください。<br>CSVファイルが手元に無い場合は、以下のリンク先からダウンロードしてください。',
                },
                step2:
                    'アップロードした学習用データが表示されています。<br>学習データには、一番右端に「正解ラベル」を示す項目があります。<br>正解ラベルは、0か1で指定されていて、Wide Learning&trade;は、<span class="negativeLabel">0はNEG</span>、<span class="positiveLabel">1はPOS</span>として表現します。<br>（例えば、哺乳類判定の場合は、NEGは「哺乳類ではない」、POSは「哺乳類である」を表します。）',
                step3: {
                    all: '学習用データの0(NEG),1(POS)の数を集計して、グラフ表示しています。',
                    labels:
                        '項目の値ごとに、データの数を集計してグラフ表示しています。0(NEG)と1(POS)で色分けしています。',
                    na: '0(NEG)と1(POS)別に、各項目の欠損値の数(値が空や、無効なデータの数)とその割合を表示しています。',
                },
                creating_kc:
                    '重要な項目の組み合わせを生成しています。<br>処理が完了するまでお待ちください。',
                finish_create_kc: '重要な項目の組み合わせを生成しました。',
            },
            step2: {
                step1:
                    '学習用データをもとに、何通りもある「項目」と「値」の組み合わせの中から、重要な組み合わせだけを生成しています。',
                training: '重要な組み合わせに重みをつけています。',
            },
            step3: {
                step1: {
                    all: 'Step2で生成した「重要な項目の組み合わせ」が、そのデータが0(NEG)か1(POS)を判断するために<br>どれほど重要かを示す、重要度が計算されています。',
                    params:
                        '下の表は、Wide Learning&trade;の評価値を表します。これは、Step1で入力した学習用データを３等分し、そのうちの2つを学習に使い、残りの1つで評価したものです（下図）。<br>なお、Step5の予測では、学習用データのすべてを学習し、Step4で入力する予測用データを用いて予測を行います。',
                    img_url: '/trials/images/step3_dataImg.svg',
                },
                step2: {
                    before:
                        '学習用データに、どの組み合わせ(重要な項目の組み合わせ)が含まれているかが確認できます。行をクリックしてください。',
                },
            },
            step4: {
                step1: {
                    before: '予測用データのCSVファイルをアップロードします。ファイルを下のスペースにドラッグ＆ドロップまたはプルダウン選択してください。<br>CSVファイルが手元に無い場合は、以下のリンク先からダウンロードしてください。',
                },
                step2: 'アップロードした予測用データが表示されています。',
                step3: {
                    labels: '項目の値ごとに、データの数を集計してグラフ表示しています。',
                    na: '各項目の欠損値の数(値が空や、無効なデータの数)とその割合を表示しています。',
                },
                predicting: '予測しています。<br>処理が完了するまでお待ちください。',
                finish_predicting: '予測が完了しました。',
            },
            step5: {
                step1: {
                    before:
                        '予測用データが 、0(NEG)と1(POS) のどちらに分類されたか結果が表示されています。<br>行をクリックすると、分類に影響を与えた「重要な項目の組み合わせ」が右側に表示されます。<br>体験ツールは予測結果の確認で終了です。ご利用ありがとうございました。',
                },
            },
        },
        tos: {
            agree: '同意します',
        },
        input: {
            train: '学習用データ',
            predict: '予測用データ',
            message: 'ドラッグ & ドロップ',
            csvSelection: '事例データ選択',
            downloads: {
                mammalian: {
                    text: 'サンプルデータ（哺乳類の判別）のダウンロードはこちら。',
                    url: '/ja/trialTool/faq.html#faq005',
                },
            },
            error: {
                text: 'Traial Toolを利用中にエラーが出た場合はこちら。',
                url: '/ja/trialTool/faq.html#faq006',
            },
        },
        caption: {
            data: {
                tabs: {
                    all: '全体',
                    na: '(欠損)',
                    labels: '項目',
                },
                na: {
                    labels: '項目',
                    count: '欠損数',
                    ratio: '欠損割合',
                },
            },
            results: {
                menu: {
                    score: 'パラメータとスコア',
                    knowledge_chunk: 'ナレッジチャンク',
                    data: 'データ一覧',
                    go_predict: 'この学習モデルを使用する',
                },
                score: {
                    evaluation_metrics: 'モデルの評価指標',
                    evaluation_value: '評価値',
                    score: 'スコア',
                    result: '結果',
                    fvalue: {
                        label: 'F値 (F-measure)',
                        description:
                            '予測結果の評価指標。<br>再現率と適合率の調和平均で定義される。',
                    },
                    precision: {
                        label: '適合率 (Precision)',
                        description: 'POSと予測したデータのうち，実際にPOSであるものの割合。',
                    },
                    recall: {
                        label: '再現率 (Recall)',
                        description: '実際にPOSであるもののうち，POSであると予測されたものの割合。',
                    },
                },
                knowledge_chunk: {
                    chunk: '重要な項目の組み合わせ',
                    summary: '一覧',
                    weight: '重要度（重み）',
                    support: 'サポート',
                    confidence: '信頼区間',
                    len: '組み合わせの長さ',
                    npos: 'POSの出現数',
                    nneg: 'NEGの出現数',
                    pos: 'POS',
                    neg: 'NEG',
                },
                data: {
                    before: 'バイナリ化前',
                    after: 'バイナリ化後',
                    no_select: '左の表からデータを選択してください。',
                    no_data_pos: '判定に必要な項目の組み合わせが十分に見つかりませんでした。<br>学習データ全体の傾向から<span class="positiveLabel">pos</span>と判定します。',
                    no_data_neg: '判定に必要な項目の組み合わせが十分に見つかりませんでした。<br>学習データ全体の傾向から<span class="negativeLabel">neg</span>と判定します。',
                },
            },
        },
        dialog: {
            button: {
                close: '閉じる',
                yes: 'はい',
                no: 'いいえ',
            },
            contents: {
                format: {
                    all: {
                        title: '初期化実行',
                        message: '全てのデータを削除します。よろしいでしょうか？',
                    },
                    predict: {
                        title: '予測用データの初期化',
                        message: '予測用データを削除します。よろしいでしょうか？',
                    },
                },
                start: {
                    creating_kc: {
                        title: '重要な項目の組み合わせを生成',
                        message:
                            '重要な項目の組み合わせを生成します。<br>生成後、自動的にStep2に遷移します。よろしいでしょうか？',
                    },
                    training: {
                        title: '重要な組み合わせに重みをつける',
                        message:
                            '重要な組み合わせに重みをつけます。<br>重みづけ終了後、自動的にStep3に遷移します。よろしいでしょうか？',
                    },
                    predict: {
                        title: '予測を開始',
                        message:
                            '予測を開始します。<br>予測終了後、自動的にStep5に遷移します。よろしいでしょうか？',
                    },
                },
            },
        },
    },
    contact: {
        title: 'お問い合わせ - Hello, Wide Learning!',
        fields: {
            subject: '件名',
            message: 'お問い合わせ内容',
            relatedContent: 'きっかけとなった当社のコンテンツ(WebサイトのURL、講演名、掲載記事、検索キーワードなど)',
            name: 'お名前',
            email: 'ご連絡先(メールアドレス)',
            company: 'お勤め先情報(所属企業・団体名)',
            agree: '同意チェックボックス',
        },
        placeholders: {
            subject: '件名をご記入ください。',
            message: 'お問い合わせ内容をご記入ください。',
            relatedContent: 'きっかけとなった当社のコンテンツ(WebサイトのURL、講演名、掲載記事、検索キーワードなど)をご記入ください。',
            name: 'お名前をご記入ください。',
            email: 'ご連絡先(メールアドレス)をご記入ください。',
            company: 'お勤め先情報(所属企業・団体名)をご記入ください。',
        },
        form: {
            title: 'お問い合わせ',
            notes: [
                '<span class="ic-required">*</span>の付いている項目は必ずご記入ください。',
                '各項目の入力文字に半角カタカナや機種依存文字は使用できません。',
            ],
            inquiryTitle: 'お問い合わせ内容',
            policyTitle: '個人情報の取り扱いについて',
            policies: [
                '本サイトでご提供いただきましたお客様の個人情報は、お問い合わせに回答させていただく目的で利用します。なお、お問い合わせ内容によっては、当該お問い合わせ内容およびお客様の連絡先を提示したうえで富士通株式会社または富士通グループ会社に回答を依頼させていただく場合がございます。',
                'お客様の入力された内容は、<a href="https://www.fujitsu.com/jp/about/resources/privacy/" target="_blank" rel="noopener noreferrer">富士通株式会社の個人情報保護ポリシー</a>に基づき、適切に管理します。',
                '情報の開示・訂正・追加・削除および利用停止を希望されるお客様は、以下のお問い合わせ先まで郵送にてご連絡ください。',
            ],
            contactInformation: {
                title: '本件に関するお問い合わせ先',
                depertment: '富士通株式会社 富士通研究所 Hello, Wide Learning! サイト担当',
                address: '住所: 〒211-8588 神奈川県川崎市中原区上小田中4-1-1',
            },
            eea: {
                title: 'EEA (European Economic Area) 加盟国所在の方は、下記注意事項をご確認のうえ、以下からお問い合わせください。なお、16歳未満の方は必ず保護者の方の同意を得たうえでお問い合わせください。',
                depertment: '富士通株式会社 富士通研究所 Hello, Wide Learning! サイト担当',
                notice_caption: '注意事項：',
                notices: [
                    '本メールアドレスでは、富士通研究所の研究活動に関するお客様からのお問い合わせをお受けしています。ただし、EEA加盟国以外に所在する方は、このメールアドレスをご利用になれません。本ページのお問い合わせフォームにご入力ください。',
                    'お名前、ご所属、メールアドレス、所在国名を明記の上、お問い合わせ内容を詳細にご記載ください。また、お問い合わせのきっかけとなった当社のコンテンツ（WebサイトのURL、講演名、掲載記事、検索キーワードなど）もご記載ください。なお、所在国名をご記載いただけない場合は回答できませんので、あらかじめご了承ください。',
                    '本メールアドレスへのご送信内容は、日本への転送および富士通の日本国内のサーバへの保存にご同意いただいたものとして扱わせていただきます。日本は、2019年1月23日現在、欧州委員会の十分性認定（GDPR Article 45 Transfers on the basis of an adequacy decision）を受けています。当社は、十分性認定に基づいて個人情報を日本へ移転します。',
                    '本メールアドレスにご提供いただきましたお客様の個人情報は、お問い合わせに回答させていただく目的で利用します。お問い合わせ内容によっては、当該お問い合わせ内容およびお客様の連絡先を提示したうえで日本国の富士通または日本国の富士通グループ会社に回答を依頼させていただく場合がございます。',
                    'お客様の個人情報は、お問い合わせに回答後6ヶ月の間、<a href="https://www.fujitsu.com/jp/about/resources/privacy/" target="_blank" rel="noopener noreferrer">富士通株式会社の個人情報保護ポリシー</a>に基づいて適切に取り扱います。',
                    'お客様は、いつでも同意の内容を撤回することが可能です。お客様には「アクセス権」、「訂正権」、「消去権」、「取扱い制限の権利」、「データポータビリティの権利」、「自動化された個人の判断に関する権利」、「異議を述べる権利」があります。権利行使される場合は、以下のお問い合わせ先まで郵送にてご連絡願います。',
                ],
                addition: 'なお、当社の対応に不服がある場合には、監督機関への申し立てを行うこともできます。',
            },
            agree: '下記、個人情報の取り扱いに同意します',
            next: '確認画面へ進む',
        },
        confirmation: {
            title: 'お問い合わせ内容の確認',
            back: '内容を修正する',
            send: '送信する',
            error: '申し訳ございません。お問い合わせの送信に失敗しました。',
        },
        finish: {
            title: 'お問い合わせ完了',
            blockTitle: 'お問い合わせ完了',
            message: 'お問い合わせありがとうございました。',
        },
    },
    error: {
        title: 'エラーが発生しました',
        message: {
            default: 'もう一度最初からやり直してください。',
            retry: 'もう一度やり直してください。',
            nodata: 'データを取得できませんでした。',
            unauthorized:
                '利用開始から一定時間が経過いたしました。<br>申し訳ございませんが、最初からやり直してください。',
            nowCalling: '現在サーバーと通信しています。<br>時間をおいて、もう一度お試しください。',
            file: {
                name: 'ファイル名が不正です。',
                encode: 'ファイルの文字コードが不正です。(許容文字コード：UTF-8, Shift_JIS)',
                format: 'ファイルの形式が不正です。(許容フォーマット：csv形式)',
                columnCount: '列数が不正です。',
                preprocessedColumCountFew:
                    '前処理後、利用可能データの列数が不足してしまいました。<br>数値によるデータ列は、正解ラベルとの関係が小さい場合に削除されます。<br>適当な範囲で値をグループ化し、文字列化することで解決する場合があります。([0, 1, 2] ⇒ [A, B, C] など) ',
                preprocessedColumCountMany:
                    '前処理後、データ列を分析のため展開した結果、上限を超えてしまいました。<br>文字列によるデータ列は、値をグループ化して種類を減らしてください。([a1, a2, a3, b1, b2] ⇒ [a, b] など)<br>順序や大きさ、度合いを表す文字列 [IIa, IIb, III] などは、[2.1, 2.2, 3.0] のような数値に変えると解決する場合があります。',
                rowCount: '行数が不正です。',
                dupuricateIndex: 'インデックスの値が重複しています。',
                dupuricateColumn: '列名が重複しています。',
                labelNa: 'ラベルの値に欠損値が含まれています。',
                labelValue: 'ラベルに0、1以外の値が含まれています。',
                allSameLabel: 'ラベルの値が全て同じです。',
                size: 'ファイルの容量がオーバーしています。最大1MBまででお願いいたします。',
                insufficientAll: '正解ラベルが1 (POS、正例) のデータと、0 (NEG、負例) のデータが共に3行以下になっています。<br>正解ラベルは、正例負例いずれも4行以上に増やしてください。',
                insufficientPos: '正解ラベルが1 (POS、正例) のデータが3行以下になっています。<br>正解ラベルは、正例負例いずれも4行以上に増やしてください。',
                insufficientNeg: '正解ラベルが0 (NEG、負例) のデータが3行以下になっています。<br>正解ラベルは、正例負例いずれも4行以上に増やしてください。',
            },
            alreadyExec: 'すでに処理が実行されています。',
            predict: {
                unmatchColumn: '列名が学習時と一致していません。',
            },
            table: {
                noData: 'データが存在しません。',
            },
        },
    },
    caseStudyCSV: {
        animals: {
            trainingText: "哺乳類判別の学習用データ",
            predictionText: "哺乳類判別の予測用データ",
            headerText: "名前,毛,羽,卵生,飛翔,水生,肉食,歯,背骨,肺呼吸,ひれ,足,しっぽ,人による飼育,ネコ科くらいのサイズか,label",
        },
        election: {
            trainingText: "選挙事例の学習用データ",
            predictionText: "選挙事例の予測用データ",
            headerText: "名前,年齢,性別,政党,ブロック,当選回数,新人現職元職,出生地=選挙区,世襲,主張_夫婦別姓,主張_財政規律,主張_健康医療,主張_子ども子育て,主張_福祉介護,主張_雇用労働,主張_年金,生年,生月,最終学歴,出身大学,学部,職業,趣味,当選",
        },
        covid: {
            trainingText: "感染拡大抑制施策学習用データ",
            predictionTextA: "感染拡大抑制施策予測用データA 未実施から施策を増やした場合",
            predictionTextB: "感染拡大抑制施策予測用データB 実際の実施施策を前倒しした場合",
            headerText: "国_基準日,[特性]地域,[特性]BCG予防接種受診率,[特性]一人当たりGDP,[特性]65歳以上人口比,[特性]平均寿命,[特性]喫煙者人口比,[特性]都市部人口比,[特性]給与所得者比,[施策]学校閉鎖後,[施策]集会制限後,[施策]営業休止後,[施策]外出制限後,[施策]国内移動制限後,[施策]交通機関閉鎖後,[施策]公共行事中止後,正解ラベル",
        },
        defect_prevention: {
            trainingText: "不良品防止施策学習用データ",
            predictionText: "不良品防止施策予測用データ",
            headerText: "ID,生産ライン,温度,圧力,電力,A剤投入量,B剤投入量,K軸回転数,J軸回転数,不良",
        }
    },
    // vuetify 内部の定義
    $vuetify: {
        badge: 'バッジ',
        close: '閉じる',
        dataIterator: {
            noResultsText: '検索結果が見つかりません。',
            loadingText: '項目をロード中です...',
        },
        dataTable: {
            itemsPerPageText: '1ページあたりの行数：',
            ariaLabel: {
                sortDescending: '降順の並び替え。',
                sortAscending: '昇順の並び替え。',
                sortNone: 'ソートされていません。',
                activateNone: 'ソートを削除するには有効にしてください。',
                activateDescending: '降順の並び替えのためには有効にしてください。',
                activateAscending: '昇順のソートのためには有効にしてください。',
            },
            sortBy: 'ソート方式',
        },
        dataFooter: {
            itemsPerPageText: '1ページあたりの件数：',
            itemsPerPageAll: 'すべて',
            nextPage: '次のページ',
            prevPage: '前のページ',
            firstPage: '一ページ目',
            lastPage: '最後のページ',
            pageText: '{0}-{1} 件目 / {2}件',
        },
        datePicker: {
            itemsSelected: '{0}日付選択',
        },
        noDataText: 'データはありません。',
        carousel: {
            prev: '前のビジュアル',
            next: '次のビジュアル',
            ariaLabel: {
                delimiter: 'Carousel slide {0} of {1}',
            },
        },
        calendar: {
            moreEvents: 'さらに{0}',
        },
        fileInput: {
            counter: '{0} ファイル',
            counterSize: '{0} ファイル (合計 {1})',
        },
        timePicker: {
            am: 'AM',
            pm: 'PM',
        },
    },
};
